import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '📚',
      title: 'Library Automation',
      description: 'Efficient cataloguing and circulation systems to reduce manual intervention and improve operational efficiency.',
      features: ['Automated cataloguing', 'Circulation management', 'Inventory control', 'User management']
    },
    {
      icon: '💻',
      title: 'Digital Resource Management',
      description: 'Solutions for managing e-resources, digitization, and digital content access, supporting both physical and virtual library environments.',
      features: ['E-resource management', 'Digitization services', 'Digital content access', 'Virtual library support']
    },
    {
      icon: '☁️',
      title: 'Cloud-based Hosting Solutions',
      description: 'Secure and scalable hosting services for library management systems like Koha, ensuring easy access and system integration.',
      features: ['Secure hosting', 'Scalable infrastructure', 'Easy access', 'System integration']
    },
    {
      icon: '🎯',
      title: 'Consulting Services',
      description: 'Expert advice and guidance to improve library systems, policies, and overall functionality through advanced IT solutions.',
      features: ['System optimization', 'Policy development', 'IT guidance', 'Best practices']
    },
    {
      icon: '🔧',
      title: 'Technical Support',
      description: '24/7 technical support and maintenance services to ensure your library systems run smoothly and efficiently.',
      features: ['24/7 support', 'System maintenance', 'Troubleshooting', 'Updates & patches']
    },
    {
      icon: '📊',
      title: 'Analytics & Reporting',
      description: 'Advanced analytics and reporting tools to help you understand library usage patterns and optimize operations.',
      features: ['Usage analytics', 'Custom reports', 'Data visualization', 'Performance metrics']
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive library management solutions tailored to your institution's needs
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card card">
              <div className="service-icon">
                <span className="icon-emoji">{service.icon}</span>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="feature-item">
                    <span className="feature-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <div className="service-action">
                <button className="btn btn-secondary">Learn More</button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="services-cta">
          <div className="cta-content">
            <h3>Ready to Transform Your Library?</h3>
            <p>Get a personalized quote for your library management needs</p>
            <button className="btn btn-primary">Get Free Quote</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
